var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Drawer",
        {
          attrs: { drawer: _vm.drawer, withHeader: false, size: _vm.size },
          on: { close: _vm.close },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "view",
            },
            [
              !_vm.showTrack && !_vm.showIsf && !_vm.showOrderDetail
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "tag" },
                      [
                        _c(
                          "el-tabs",
                          {
                            attrs: { type: "card" },
                            on: { "tab-click": _vm.handleClick },
                            model: {
                              value: _vm.active,
                              callback: function ($$v) {
                                _vm.active = $$v
                              },
                              expression: "active",
                            },
                          },
                          [
                            _c("el-tab-pane", {
                              attrs: { label: "基本信息", name: "0" },
                            }),
                            _vm.mblDetail.pickUpType
                              ? _c("el-tab-pane", {
                                  attrs: { label: "货物信息", name: "2" },
                                })
                              : _vm._e(),
                            !_vm.billType
                              ? _c("el-tab-pane", {
                                  attrs: { label: "船司轨迹", name: "3" },
                                })
                              : _vm._e(),
                            _vm.mblDetail.clearenceType
                              ? _c("el-tab-pane", {
                                  attrs: { label: "清关轨迹", name: "4" },
                                })
                              : _vm._e(),
                            _c("el-tab-pane", {
                              attrs: { label: "跟进人信息", name: "5" },
                            }),
                            _c("el-tab-pane", {
                              attrs: {
                                label: "邮件记录(" + _vm.emailList.length + ")",
                                name: "6",
                              },
                            }),
                            _c("el-tab-pane", {
                              attrs: { label: "提单备注", name: "7" },
                            }),
                          ],
                          1
                        ),
                        _c("i", {
                          staticClass: "el-icon-close closeIcon",
                          on: { click: _vm.close },
                        }),
                      ],
                      1
                    ),
                    _vm.active === "0"
                      ? _c(
                          "div",
                          { staticClass: "panel panelActive1" },
                          [
                            _c(
                              "div",
                              { staticClass: "panel2" },
                              [
                                _c("div", { staticClass: "panel-title" }, [
                                  _c(
                                    "span",
                                    [
                                      _c("svg-icon", {
                                        style: { "font-size": 20 },
                                        attrs: {
                                          iconClass: "panelTitle-icon",
                                          className: "icon",
                                        },
                                      }),
                                      _vm._v(" 基本信息 "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "label-mark",
                                          staticStyle: {
                                            margin: "0 10px",
                                            display: "inline-block",
                                            background: "#e9ecf3",
                                            padding: "0 5px",
                                          },
                                        },
                                        [_vm._v("提单号")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "label-info" },
                                        [_vm._v(_vm._s(_vm.mblDetail.mblNo))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "label-mark",
                                          staticStyle: {
                                            margin: "0 10px",
                                            display: "inline-block",
                                            background: "#e9ecf3",
                                            padding: "0 5px",
                                          },
                                        },
                                        [_vm._v("件数")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "label-info" },
                                        [_vm._v(_vm._s(_vm.mblDetail.qty))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "label-mark",
                                          staticStyle: {
                                            margin: "0 10px",
                                            display: "inline-block",
                                            background: "#e9ecf3",
                                            padding: "0 5px",
                                          },
                                        },
                                        [_vm._v("方数")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "label-info" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.mblDetail.weightCbm)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "label-mark",
                                          staticStyle: {
                                            margin: "0 10px",
                                            display: "inline-block",
                                            background: "#e9ecf3",
                                            padding: "0 5px",
                                          },
                                        },
                                        [_vm._v("重量")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "label-info" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.mblDetail.weightKgs)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "opt-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewDetails("track")
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/bill/track.png"),
                                        },
                                      }),
                                      _vm._v(" 提单轨迹 "),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.billType
                                                ? "航空公司"
                                                : "船公司"
                                            )
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.mblDetail.transportName)
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("目的国家")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.mblDetail.countryCode)
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("ETD")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail.etd
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("ETA")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail.eta
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("ATD")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail.atd
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("ATA")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail.ata
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.billType
                                                ? "始发机场"
                                                : "始发地"
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 155,
                                                expression: "155",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail.originHarborName
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.billType
                                                ? "目的机场"
                                                : "目的地"
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 155,
                                                expression: "155",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail
                                                  .destinationHarborName
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("清关方式")]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "rgb(18,88,188)",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "type",
                                                staticStyle: {
                                                  background:
                                                    "rgba(35, 149, 243, 0.1)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.mblDetail
                                                        .clearenceType
                                                        ? "平台清"
                                                        : "自清"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm.mblDetail.clearenceType
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.mblDetail?.clearence
                                                        ?.clearenceSupplierName
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("提货方式")]),
                                        _c(
                                          "p",
                                          { staticStyle: { color: "#9d67fe" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "type",
                                                staticStyle: {
                                                  background:
                                                    "rgba(157, 103, 254, 0.1)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.mblDetail.pickUpType
                                                        ? _vm.mblDetail
                                                            .pickUpType === 1
                                                          ? "直送"
                                                          : "回仓"
                                                        : "自提"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm.mblDetail.pickUpType
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.mblDetail?.pickUp
                                                        ?.pickUpSupplierName
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.mblDetail.pickUpType === 1 &&
                                            (_vm.mblDetail.pickUp
                                              .sendWayItems[0].type === 2 ||
                                              _vm.mblDetail.pickUp
                                                .sendWayItems[0].type === 3 ||
                                              _vm.mblDetail.pickUp
                                                .sendWayItems[0].type === 102)
                                              ? _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "bottom-end",
                                                      width: "474",
                                                      trigger: "hover",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "address-content",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "address-lable",
                                                          },
                                                          [_vm._v("直送地址")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "address-value",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "lable",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "公司名"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .mblDetail
                                                                        .pickUp
                                                                        .sendWayItems[0]
                                                                        ?.companyName ||
                                                                        _vm
                                                                          .mblDetail
                                                                          .pickUp
                                                                          .sendWayItems[0]
                                                                          ?.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "lable",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "20px",
                                                                  },
                                                                },
                                                                [_vm._v("邮编")]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .mblDetail
                                                                        .pickUp
                                                                        .sendWayItems[0]
                                                                        ?.postalCode
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "lable",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "电话"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .mblDetail
                                                                          .pickUp
                                                                          .sendWayItems[0]
                                                                          ?.phone
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "lable",
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "20px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "邮箱"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .mblDetail
                                                                          .pickUp
                                                                          .sendWayItems[0]
                                                                          ?.email
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "address-detail",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "lable",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "地址"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .mblDetail
                                                                          .pickUp
                                                                          .sendWayItems[0]
                                                                          ?.addressLine1
                                                                      ) +
                                                                        _vm._s(
                                                                          _vm
                                                                            .mblDetail
                                                                            .pickUp
                                                                            .sendWayItems[0]
                                                                            ?.addressLine2
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("img", {
                                                      staticStyle: {
                                                        "vertical-align": "sub",
                                                      },
                                                      attrs: {
                                                        slot: "reference",
                                                        src: require("@/assets/images/bill/address.png"),
                                                      },
                                                      slot: "reference",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("提单类型")]),
                                        _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.mblDetail.classification
                                                  ? "分单"
                                                  : "直单"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _vm.userInfo?.typeEnum !== 102
                                        ? _c("div", { staticClass: "field" }, [
                                            _c("label", [_vm._v("提单文件")]),
                                            _c("p", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "check_file",
                                                  on: {
                                                    click: _vm.checkBillFile,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-search",
                                                  }),
                                                  _vm._v("查看提单文件 "),
                                                ]
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("清关状态")]),
                                        _c("p", [
                                          _c(
                                            "span",
                                            { staticClass: "bill-status" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.mblDetail
                                                      .clearenceStatusName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("提货状态")]),
                                        _c("p", [
                                          _c(
                                            "span",
                                            { staticClass: "bill-status" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.mblDetail
                                                      .pickUpSplitDeliveryStatusName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("确认时间")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail.entryDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm.mblDetail.clearenceType &&
                                    _vm.mblDetail.clearence?.isf?.amsscac
                                      ? _c("el-col", { attrs: { span: 8 } }, [
                                          _c("div", { staticClass: "field" }, [
                                            _c("label", [_vm._v("ISF信息")]),
                                            _vm.userInfo?.typeEnum !== 102
                                              ? _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "text",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.viewDetails(
                                                              "isf"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("详情")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("接收DO邮箱")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 190,
                                                expression: "190",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail?.clearence
                                                  ?.receivedDoEmail
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("接收DO公司名称")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 190,
                                                expression: "190",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail?.clearence
                                                  ?.receivedDoCompany
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("原产国")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 190,
                                                expression: "190",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail?.originCountry
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("是否申报ISF")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 190,
                                                expression: "190",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail?.isDeclareISF
                                                  ? "是"
                                                  : "否"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("卸货港")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 190,
                                                expression: "190",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail?.dischargeHarbor
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("卸货港日期")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 190,
                                                expression: "190",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail
                                                  ?.dischargeHarborDate
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("DO")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail?.clearence?.doDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("AN")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail?.clearence?.anDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("清关模式")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.mblDetail?.clearanceModeExt
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("发货人/Shipper")]),
                                        _c(
                                          "div",
                                          { staticClass: "field-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.shipperNameOptions?.name
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("公司名"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .shipperNameOptions
                                                                ?.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.shipperNameOptions?.taxNo &&
                                                _vm.userInfo?.typeEnum !== 102
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("税号"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .shipperNameOptions
                                                                ?.taxNo
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_bottom" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.shipperNameOptions
                                                            ?.address
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.shipperNameOptions
                                                            ?.cityAddress
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.shipperNameOptions
                                                            ?.provinceEnName
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.shipperNameOptions
                                                            ?.countryName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.shipperNameOptions
                                                          ?.postcode
                                                          ? _vm
                                                              .shipperNameOptions
                                                              ?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v("收货人/Consignee"),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "field-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.consigneeNameOptions?.name
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("公司名"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .consigneeNameOptions
                                                                ?.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.shipperNameOptions?.taxNo &&
                                                _vm.userInfo?.typeEnum !== 102
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("税号"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .shipperNameOptions
                                                                ?.taxNo
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_bottom" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .consigneeNameOptions
                                                            ?.address
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .consigneeNameOptions
                                                            ?.cityAddress
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .consigneeNameOptions
                                                            ?.provinceEnName
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .consigneeNameOptions
                                                            ?.countryName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.consigneeNameOptions
                                                          ?.postcode
                                                          ? _vm
                                                              .consigneeNameOptions
                                                              ?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v("通知方/Notify party"),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "field-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.notifyPartyOptions?.name
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("公司名"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .notifyPartyOptions
                                                                ?.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.notifyPartyOptions?.taxNo &&
                                                _vm.userInfo?.typeEnum !== 102
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("税号"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .notifyPartyOptions
                                                                ?.taxNo
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_bottom" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.notifyPartyOptions
                                                            ?.address
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.notifyPartyOptions
                                                            ?.cityAddress
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.notifyPartyOptions
                                                            ?.provinceEnName
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.notifyPartyOptions
                                                            ?.countryName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.notifyPartyOptions
                                                          ?.postcode
                                                          ? _vm
                                                              .notifyPartyOptions
                                                              ?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v("制造商/Manufacturer"),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "field-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.manufacturerOptions?.name
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("公司名"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .manufacturerOptions
                                                                ?.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.manufacturerOptions
                                                  ?.taxNo &&
                                                _vm.userInfo?.typeEnum !== 102
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("税号"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .manufacturerOptions
                                                                ?.taxNo
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_bottom" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .manufacturerOptions
                                                            ?.address
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .manufacturerOptions
                                                            ?.cityAddress
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .manufacturerOptions
                                                            ?.provinceEnName
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .manufacturerOptions
                                                            ?.countryName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.manufacturerOptions
                                                          ?.postcode
                                                          ? _vm
                                                              .manufacturerOptions
                                                              ?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [
                                          _vm._v("进口商/Importer"),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "field-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.importerOptions?.name
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("公司名"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .importerOptions
                                                                ?.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.importerOptions
                                                  ?.taxNumber &&
                                                _vm.userInfo?.typeEnum !== 102
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("税号"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .importerOptions
                                                                ?.taxNumber
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_bottom" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.importerOptions
                                                            ?.address
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.importerOptions
                                                            ?.cityAddress
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.importerOptions
                                                            ?.provinceEnName
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm.importerOptions
                                                            ?.countryName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.importerOptions
                                                          ?.postcode
                                                          ? _vm.importerOptions
                                                              ?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                          },
                                          [
                                            _vm._v("最终收货人"),
                                            _c("br"),
                                            _vm._v("Ultimate consignee"),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.ultimateConsigneeOptions
                                                  ?.name
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("公司名"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .ultimateConsigneeOptions
                                                                ?.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_top" },
                                              [
                                                _vm.ultimateConsigneeOptions
                                                  ?.taxNo &&
                                                _vm.userInfo?.typeEnum !== 102
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "field3" },
                                                      [
                                                        _c("span", [
                                                          _vm._v("税号"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .ultimateConsigneeOptions
                                                                ?.taxNo
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-c_bottom" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .ultimateConsigneeOptions
                                                            ?.address
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .ultimateConsigneeOptions
                                                            ?.cityAddress
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .ultimateConsigneeOptions
                                                            ?.provinceEnName
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(
                                                          _vm
                                                            .ultimateConsigneeOptions
                                                            ?.countryName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .ultimateConsigneeOptions
                                                          ?.postcode
                                                          ? _vm
                                                              .ultimateConsigneeOptions
                                                              ?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "panel2" },
                              [
                                _c("div", { staticClass: "panel-title" }, [
                                  _c(
                                    "div",
                                    [
                                      _c("svg-icon", {
                                        style: { "font-size": 20 },
                                        attrs: {
                                          iconClass: "panelTitle-icon",
                                          className: "icon",
                                        },
                                      }),
                                      _vm._v(" 查验信息 "),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("放行时间")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.mblDetail?.clearence
                                                ?.releaseDate
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("是否查验")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.mblDetail?.clearence?.isHold
                                                ? "是"
                                                : "否"
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("查验原因")]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 510,
                                                expression: "510",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mblDetail?.clearence
                                                  ?.holdReason
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            !_vm.billType
                              ? _vm._l(
                                  _vm.mblDetail.container,
                                  function (item, $index) {
                                    return _c(
                                      "div",
                                      { key: $index, staticClass: "panel2" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "panel-title" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "panel-titleInfo",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("svg-icon", {
                                                      style: {
                                                        "font-size": 20,
                                                      },
                                                      attrs: {
                                                        iconClass:
                                                          "panelTitle-icon",
                                                        className: "icon",
                                                      },
                                                    }),
                                                    _vm._v(" 柜子信息 "),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !_vm.openInfo,
                                                        expression: "!openInfo",
                                                      },
                                                    ],
                                                    staticClass: "roughly",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "roughly-item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "flex_c_c",
                                                          },
                                                          [_vm._v("柜号")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.containerNumber
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "roughly-item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "flex_c_c",
                                                          },
                                                          [_vm._v("柜型")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.containertype
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "open flex_c_c",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.openInfo = !_vm.openInfo
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require(`@/assets/images/bill/${
                                                      _vm.openInfo
                                                        ? "packUp"
                                                        : "open"
                                                    }.png`),
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.openInfo
                                                        ? "收起"
                                                        : "展开"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.openInfo,
                                                expression: "openInfo",
                                              },
                                            ],
                                          },
                                          [
                                            _c(
                                              "el-row",
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("柜号"),
                                                        ]),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: 155,
                                                                expression:
                                                                  "155",
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.containerNumber
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("柜型"),
                                                        ]),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: 155,
                                                                expression:
                                                                  "155",
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.containertype
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("船名"),
                                                        ]),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: 155,
                                                                expression:
                                                                  "155",
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.vesselName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-row",
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("船次/航次"),
                                                        ]),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: 155,
                                                                expression:
                                                                  "155",
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.voyageNo
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("航线"),
                                                        ]),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: 155,
                                                                expression:
                                                                  "155",
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.routeLine
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("封条号"),
                                                        ]),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: 155,
                                                                expression:
                                                                  "155",
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.sealNumber
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-row",
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("卸船日期"),
                                                        ]),
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateFilete"
                                                              )(
                                                                item.dischargeDate
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("可提柜日期"),
                                                        ]),
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateFilete"
                                                              )(
                                                                item.availableDate
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "field" },
                                                      [
                                                        _c("label", [
                                                          _vm._v("还空柜日期"),
                                                        ]),
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateFilete"
                                                              )(
                                                                item.emptyReturnedDate
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.active === "2"
                      ? _c("div", { staticClass: "panel panelActive3" }, [
                          _c("div", { staticClass: "panel2" }, [
                            _c(
                              "div",
                              { staticClass: "panel-title" },
                              [
                                _c("svg-icon", {
                                  style: { "font-size": 20 },
                                  attrs: {
                                    iconClass: "panelTitle-icon",
                                    className: "icon",
                                  },
                                }),
                                _vm._v(" 提货信息 "),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "panle-container" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 12 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("预约提货时间")]),
                                        _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("dateFilete")(
                                                  _vm.mblDetail?.pickUp
                                                    ?.picExpactPickUpDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("el-col", { attrs: { span: 12 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("提货时间")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateFilete")(
                                                _vm.mblDetail?.pickUp
                                                  ?.picPickUpDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 12 } }, [
                                      _c("div", { staticClass: "field" }, [
                                        _c("label", [_vm._v("状态")]),
                                        _c("p", [
                                          _c(
                                            "span",
                                            { staticClass: "status" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.config.billShipSubtabOptions[
                                                    _vm.mblDetail.status
                                                  ]?.find(
                                                    (a) =>
                                                      a.value ==
                                                      _vm.mblDetail.subStatus
                                                  )?.label
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "panel-title" },
                              [
                                _c("svg-icon", {
                                  style: { "font-size": 20 },
                                  attrs: {
                                    iconClass: "panelTitle-icon",
                                    className: "icon",
                                  },
                                }),
                                _vm._v(" 派送方式 "),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "panle-container panel3" },
                              [
                                _c("BaseTable", {
                                  attrs: {
                                    height: _vm.height - 550,
                                    tableData: _vm.tableData1,
                                    isPager: false,
                                    border: true,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "opt",
                                        fn: function (row) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "table-opt" },
                                              [
                                                _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "left",
                                                      width: "300",
                                                      trigger: "hover",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "view-detail",
                                                      },
                                                      _vm._l(
                                                        row.scope.eventItems,
                                                        function (
                                                          item,
                                                          $index
                                                        ) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: $index,
                                                              staticClass:
                                                                "eventItems",
                                                            },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.eventDate
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.title
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item.description
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _c("img", {
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: {
                                                        slot: "reference",
                                                        src: require("@/assets/images/bill/detail.png"),
                                                      },
                                                      slot: "reference",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "remarks",
                                        fn: function (row) {
                                          return [
                                            row.scope.remarks
                                              ? _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "bottom-end",
                                                      width: "440",
                                                      trigger: "hover",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "remarks-box",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "remarks-header",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "备注内容"
                                                              ),
                                                            ]),
                                                            _c(
                                                              "span",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCopy(
                                                                        row
                                                                          .scope
                                                                          .remarks
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/images/order/copy3.png"),
                                                                  },
                                                                }),
                                                                _vm._v("复制"),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "remarks-body",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.scope
                                                                    .remarks
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("img", {
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: {
                                                        slot: "reference",
                                                        src: require("@/assets/images/bill/detail.png"),
                                                      },
                                                      slot: "reference",
                                                    }),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("--")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "arrivalQty",
                                        fn: function (row) {
                                          return [
                                            _c("p", [
                                              _c(
                                                "span",
                                                { staticClass: "lable" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        row.scope.arrivalQty ||
                                                          0
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "sufix" },
                                                    [_vm._v("件")]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "lable" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.scope.square || 0
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sufix" },
                                                      [_vm._v("CBM")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "lable" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.scope.weight || 0
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sufix" },
                                                      [_vm._v("KG")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "departureQty",
                                        fn: function (row) {
                                          return [
                                            _c("p", [
                                              _c(
                                                "span",
                                                { staticClass: "lable" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        row.scope
                                                          .departureQty || 0
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "sufix" },
                                                    [_vm._v("件")]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "lable" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.scope
                                                            .departureCbm || 0
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sufix" },
                                                      [_vm._v("板")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "lable" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.scope.weight || 0
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sufix" },
                                                      [_vm._v("KG")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "typeName",
                                        fn: function (row) {
                                          return [
                                            row.scope.estimatedDeliveryTime
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "estimatedDeliveryTime flex_c_c",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 预计送仓日期:" +
                                                        _vm._s(
                                                          row.scope.estimatedDeliveryTime.slice(
                                                            0,
                                                            row.scope
                                                              .estimatedDeliveryTime
                                                              .length - 9
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              { staticClass: "typeName" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.scope.code
                                                        ? `${row.scope.typeName}-${row.scope.code}`
                                                        : row.scope.typeName
                                                    ) +
                                                    " "
                                                ),
                                                (_vm.mblDetail.pickUpType ===
                                                  1 ||
                                                  _vm.mblDetail.pickUpType ===
                                                    2) &&
                                                (row.scope.type === 2 ||
                                                  row.scope.type === 3 ||
                                                  row.scope.type === 102)
                                                  ? _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement:
                                                            "bottom-end",
                                                          width: "474",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "address-content",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "address-lable",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "直送地址"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "address-value",
                                                              },
                                                              [
                                                                _c("p", [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "lable",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "公司名"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "value",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row
                                                                            .scope
                                                                            ?.companyName ||
                                                                            row
                                                                              .scope
                                                                              ?.attentionName
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "lable",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-left":
                                                                            "20px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "仓库编码"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "value",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row
                                                                            .scope
                                                                            ?.code
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "lable",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-left":
                                                                            "20px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "邮编"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "value",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row
                                                                            .scope
                                                                            ?.postalCode
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-top":
                                                                          "5px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "lable",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "电话"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            row
                                                                              .scope
                                                                              ?.phone
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "lable",
                                                                        staticStyle:
                                                                          {
                                                                            "margin-left":
                                                                              "20px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "邮箱"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            row
                                                                              .scope
                                                                              ?.email
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "address-detail",
                                                                    staticStyle:
                                                                      {
                                                                        "margin-top":
                                                                          "5px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "lable",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "地址"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            row
                                                                              .scope
                                                                              ?.addressLine1
                                                                          ) +
                                                                            _vm._s(
                                                                              row
                                                                                .scope
                                                                                ?.addressLine2
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("img", {
                                                          staticStyle: {
                                                            "vertical-align":
                                                              "sub",
                                                          },
                                                          attrs: {
                                                            slot: "reference",
                                                            src: require("@/assets/images/bill/address3.png"),
                                                          },
                                                          slot: "reference",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    244668318
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.active === "3"
                      ? _c(
                          "div",
                          { staticClass: "panel panelActive4" },
                          [
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("提单号")]),
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.containerEvents.mblNo)),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("柜号")]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.containerEvents.containerNumber
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("ETD-ETA")]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFilete")(
                                            _vm.containerEvents.etd
                                          )
                                        ) +
                                          "-" +
                                          _vm._s(
                                            _vm._f("dateFilete")(
                                              _vm.containerEvents.eta
                                            )
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("ATD-ATA")]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFilete")(
                                            _vm.containerEvents.atd
                                          )
                                        ) +
                                          "-" +
                                          _vm._s(
                                            _vm._f("dateFilete")(
                                              _vm.containerEvents.ata
                                            )
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("提柜日期")]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFilete")(
                                            _vm.containerEvents.gateOutDate
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("还空日期")]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFilete")(
                                            _vm.containerEvents.emptyReturnDate
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("label", [_vm._v("轨迹来源")]),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.mblDetail?.terminalSupplierName
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c("BaseTable", {
                              staticStyle: { "margin-top": "20px" },
                              attrs: {
                                height: _vm.height - 238,
                                tableData: _vm.tableData6,
                                isPager: false,
                                border: true,
                              },
                            }),
                            _c("div", { staticClass: "panel-btn-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "panel-btn",
                                  staticStyle: {
                                    background: "rgb(18,88,188)",
                                    color: "#ffffff",
                                  },
                                  on: { click: _vm.reloadshipPart },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/bill/reload.png"),
                                    },
                                  }),
                                  _vm._v(" 刷新 "),
                                ]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.active === "4"
                      ? _c(
                          "div",
                          { staticClass: "panel panelActive4" },
                          [
                            _c(
                              "el-row",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          width: "auto",
                                          padding: "0 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Manifested Port of Unlading/Import"
                                        ),
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.amsOldData.arrivalPortCode)
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          width: "auto",
                                          padding: "0 10px",
                                        },
                                      },
                                      [_vm._v("Departure Port:")]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.amsOldData.departurePortCode)
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          width: "auto",
                                          padding: "0 10px",
                                        },
                                      },
                                      [_vm._v("Departure Date:")]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFilete")(
                                            _vm.amsOldData.atd
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "ams",
                                staticStyle: { width: "100%", height: "100%" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "amsList" },
                                  _vm._l(_vm.amsData, function (item, $index) {
                                    return _c(
                                      "div",
                                      { key: $index, staticClass: "list" },
                                      [
                                        _c("div", { staticClass: "list-top" }, [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v(
                                              _vm._s(
                                                item.blType === "M"
                                                  ? "提单号"
                                                  : "分单号"
                                              ) + "："
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "value",
                                                style: {
                                                  color: !item.isRed
                                                    ? "#333333"
                                                    : "#FE453D",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.number))]
                                            ),
                                          ]),
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("类型："),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  "value",
                                                  item.blType === "M"
                                                    ? "Master"
                                                    : "House",
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.blType === "M"
                                                      ? "Master"
                                                      : "House"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          !_vm.rowData.type
                                            ? _c(
                                                "span",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v("ISF On File："),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "value",
                                                      style: {
                                                        color: item.isf
                                                          ? "#333333"
                                                          : "#FE453D",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.isf
                                                            ? "YES"
                                                            : "NO"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("数量："),
                                            _c(
                                              "span",
                                              { staticClass: "value" },
                                              [_vm._v(_vm._s(item.qty))]
                                            ),
                                          ]),
                                          !_vm.rowData.type
                                            ? _c(
                                                "span",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v("船名："),
                                                  _c(
                                                    "span",
                                                    { staticClass: "value" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.vesselName)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          !_vm.rowData.type
                                            ? _c(
                                                "span",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v("船次："),
                                                  _c(
                                                    "span",
                                                    { staticClass: "value" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.voyageNumber
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("到达日期："),
                                            _c(
                                              "span",
                                              { staticClass: "value" },
                                              [_vm._v(_vm._s(item.lastRunTime))]
                                            ),
                                          ]),
                                          item.blType !== "M"
                                            ? _c(
                                                "span",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v("[Inbond No:"),
                                                  _c(
                                                    "span",
                                                    { staticClass: "value" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.inBondNumber
                                                        ) + "]"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "list-middle" },
                                          _vm._l(
                                            item.truckItems,
                                            function (event, index) {
                                              return _c("div", { key: index }, [
                                                _c(
                                                  "span",
                                                  { staticClass: "icon" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        event.dispositionCode
                                                      )
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/images/bill/qun.png"),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "desc" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          event.dispositionDesc
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "quantity" },
                                                  [
                                                    _vm._v(
                                                      " Quantity： " +
                                                        _vm._s(
                                                          event.manifestQuantity
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "quantity" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          event.eventDate
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "panel-btn-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "panel-btn",
                                  staticStyle: {
                                    background: "rgb(18,88,188)",
                                    color: "#ffffff",
                                  },
                                  on: { click: _vm.reSub },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/bill/reload.png"),
                                    },
                                  }),
                                  _vm._v(" 重新订阅 "),
                                ]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.active === "5"
                      ? _c("div", { staticClass: "panel panelActive1" }, [
                          _c(
                            "div",
                            { staticClass: "panel2" },
                            [
                              !_vm.billType
                                ? _c(
                                    "div",
                                    { staticClass: "panel-title" },
                                    [
                                      _c("svg-icon", {
                                        style: { "font-size": 20 },
                                        attrs: {
                                          iconClass: "panelTitle-icon",
                                          className: "icon",
                                        },
                                      }),
                                      _vm._v(" 基本信息 "),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c("div", { staticClass: "field" }, [
                                      _c("label", [_vm._v("操作")]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.mblHandlers.operator)
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c("div", { staticClass: "field" }, [
                                      _c("label", [_vm._v("客服")]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.mblHandlers.customer)
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c("div", { staticClass: "field" }, [
                                      _c("label", [_vm._v("财务")]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.mblHandlers.financer)
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.active === "6"
                      ? _c(
                          "div",
                          { staticClass: "panel panelActive4 email-record" },
                          [
                            _c(
                              "div",
                              { staticClass: "mbl-info-search" },
                              [
                                _c("BaseDateCommon", {
                                  attrs: { width: "320" },
                                  model: {
                                    value: _vm.emailForm.contractDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.emailForm,
                                        "contractDate",
                                        $$v
                                      )
                                    },
                                    expression: "emailForm.contractDate",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "group-box" },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "input-search",
                                        attrs: { placeholder: "发件人/主题" },
                                        model: {
                                          value: _vm.emailForm.search,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.emailForm,
                                              "search",
                                              $$v
                                            )
                                          },
                                          expression: "emailForm.search",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticStyle: { background: "none" },
                                          attrs: {
                                            slot: "append",
                                            icon: "el-icon-search",
                                            size: "small",
                                          },
                                          on: { click: _vm.getMBLEmail },
                                          slot: "append",
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.emailList.length == 0
                              ? _c("el-empty")
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "mbl-info-section" },
                              _vm._l(_vm.emailList, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "mbl-info",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEmailDialog(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "info-row email-item-title",
                                      },
                                      [_vm._v(" " + _vm._s(item.subject) + " ")]
                                    ),
                                    _c("div", { staticClass: "info-row" }, [
                                      _c(
                                        "span",
                                        { staticClass: "info-label" },
                                        [_vm._v("发件人：")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "info-value" },
                                        [
                                          item.sender.address !=
                                          item.sender.name
                                            ? [
                                                _vm._v(
                                                  _vm._s(item.sender.name) + "<"
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(_vm._s(item.sender.address)),
                                          item.sender.address !=
                                          item.sender.name
                                            ? [_vm._v(">")]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "info-label ml-20" },
                                        [_vm._v("发送时间：")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "info-value" },
                                        [_vm._v(_vm._s(item.receivedDate))]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "info-row" }, [
                                      _c(
                                        "span",
                                        { staticClass: "info-label" },
                                        [_vm._v("收件人：")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "info-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.recipients
                                                .map((e) => e.address)
                                                .join("、")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    item.cc && item.cc.length
                                      ? _c("div", { staticClass: "info-row" }, [
                                          _c(
                                            "span",
                                            { staticClass: "info-label" },
                                            [_vm._v("抄送：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "info-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.cc
                                                    .map((e) => e.address)
                                                    .join("、")
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    item.attachments && item.attachments.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "info-row attachments-row",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "info-label" },
                                              [_vm._v("附件：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "attachment-list",
                                              },
                                              _vm._l(
                                                item.attachments,
                                                function (file, idx) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: idx,
                                                      staticClass:
                                                        "attachment-tag",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.downLoad(
                                                            file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      file.fileName
                                                        .split(".")
                                                        .pop()
                                                        .toLowerCase() == "pdf"
                                                        ? _c("svg-icon", {
                                                            attrs: {
                                                              iconClass: "pdf",
                                                              className: "icon",
                                                            },
                                                          })
                                                        : file.fileName
                                                            .split(".")
                                                            .pop()
                                                            .toLowerCase() ==
                                                          "xlsx"
                                                        ? _c("svg-icon", {
                                                            attrs: {
                                                              iconClass: "xlsx",
                                                              className: "icon",
                                                            },
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "el-icon-document",
                                                          }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(file.fileName)
                                                        ),
                                                      ]),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-download",
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.active === "7"
                      ? _c(
                          "div",
                          { staticClass: "panel panelActive4" },
                          [
                            _c("BaseTable", {
                              staticStyle: { "margin-top": "20px" },
                              attrs: {
                                height: _vm.height - 200,
                                tableData: {
                                  ..._vm.tableData7,
                                  columns: _vm.mblDetail?.mblRemarks || [],
                                },
                                isPager: false,
                                border: true,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.showTrack || _vm.showIsf || _vm.showOrderDetail
                ? _c("div", { staticClass: "back" }, [
                    _c("div", { staticClass: "title" }, [
                      _c(
                        "div",
                        { staticClass: "before", on: { click: _vm.back } },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/bill/back.png"),
                              alt: "",
                            },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.showOrderDetail
                                  ? "返回订单详情"
                                  : "返回详情"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "current" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/bill/arrow.png"),
                            alt: "",
                          },
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.showIsf && "ISF信息") ||
                                (_vm.showTrack && "提单轨迹") ||
                                (_vm.showOrderDetail && "订单详情")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("i", {
                      staticClass: "el-icon-close closeIcon",
                      on: { click: _vm.close },
                    }),
                  ])
                : _vm._e(),
              _vm.showTrack
                ? _c("div", { staticClass: "log-body" }, [
                    _c("div", { staticClass: "track-num" }, [
                      _vm._v(" 提单号："),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(_vm._s(_vm.mblDetail.blNo)),
                      ]),
                    ]),
                    _c("div", { staticClass: "track-other" }, [
                      _c("div", { staticClass: "country" }, [
                        _c("div", { staticClass: "country-code" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.mblDetail.originHarborName.split("-")[0]
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.mblDetail.originHarborName.split("-")[1]
                              )
                            ),
                          ]),
                        ]),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/order/guide.png"),
                          },
                        }),
                        _c("div", { staticClass: "country-code" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.mblDetail.destinationHarborName.split(
                                  "-"
                                )[0]
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.mblDetail.destinationHarborName.split(
                                  "-"
                                )[1]
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "navication flex_c_c" }, [
                        _vm._v(" 当前状态："),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.config.billShipSubtabOptions[
                                _vm.mblDetail.status
                              ]?.find((a) => a.value == _vm.mblDetail.subStatus)
                                ?.label
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "track-step" },
                      _vm._l(_vm.trackList, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "step-item" },
                          [
                            _c(
                              "div",
                              {
                                class: [
                                  "step-title",
                                  index === 0
                                    ? "blue"
                                    : item.descriptionCH.indexOf("海关查验") >
                                        -1 || item.statusCode === "HOLD_SYS"
                                    ? "check"
                                    : "",
                                ],
                              },
                              [
                                _c("div", { staticClass: "dot" }, [
                                  _c("div", {
                                    class: [
                                      "step-dot",
                                      index === 0
                                        ? "blue-dot"
                                        : item.descriptionCH.indexOf(
                                            "海关查验"
                                          ) > -1 ||
                                          item.statusCode === "HOLD_SYS"
                                        ? "check-dot"
                                        : "",
                                    ],
                                  }),
                                ]),
                                _c("div", { staticClass: "step-time" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.eventDate) +
                                      "  " +
                                      _vm._s(item.location) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                class: [
                                  "step-info",
                                  index === 0
                                    ? "blue"
                                    : item.descriptionCH.indexOf("海关查验") >
                                        -1 || item.statusCode === "HOLD_SYS"
                                    ? "check"
                                    : "",
                                ],
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(item.descriptionCH)),
                                ]),
                                item.isOpen && item.outboundDetails
                                  ? _vm._l(
                                      item.outboundDetails,
                                      function (a, i) {
                                        return _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass: "step-detail",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "step-detail_item",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "detail-label1",
                                                  },
                                                  [_vm._v("派送方式")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "detail-info",
                                                  },
                                                  [_vm._v(_vm._s(a?.typeName))]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-row",
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "step-detail_item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-label1",
                                                          },
                                                          [_vm._v("总件数")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                a?.qty || 0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 14 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "step-detail_item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-label2",
                                                          },
                                                          [_vm._v("ISP")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                a?.ispFile
                                                                  ?.uploadDate
                                                                  ? a?.ispFile
                                                                      ?.uploadDate
                                                                  : "无"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        a?.ispFile?.fileGuid
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "viewFile flex_c_c",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.viewFile(
                                                                        a
                                                                          ?.ispFile
                                                                          ?.fileGuid
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("查看")]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-row",
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "step-detail_item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-label1",
                                                          },
                                                          [_vm._v("出仓")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                a?.departureQty
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 14 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "step-detail_item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-label2",
                                                          },
                                                          [_vm._v("POD")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "detail-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                a?.podFile
                                                                  ?.uploadDate
                                                                  ? a?.podFile
                                                                      ?.uploadDate
                                                                  : "无"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        a?.podFile?.fileGuid
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "viewFile flex_c_c",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.viewFile(
                                                                        a
                                                                          ?.podFile
                                                                          ?.fileGuid
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("查看")]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                            index !== _vm.trackList.length - 1
                              ? _c("div", {
                                  class: [
                                    "step-line",
                                    ,
                                    index === 0 ? "blue-line" : "",
                                  ],
                                })
                              : _vm._e(),
                            item.outboundDetails && item.outboundDetails.length
                              ? _c("i", {
                                  class: [
                                    item.isOpen
                                      ? "el-icon-arrow-up"
                                      : "el-icon-arrow-down",
                                    "arrow",
                                  ],
                                  attrs: {
                                    title: item.isOpen ? "收起" : "展开",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.isOepn(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm.showIsf
                ? _c("div", { staticClass: "log-body" }, [
                    _c(
                      "div",
                      { staticClass: "isf_info" },
                      [
                        _c("div", { staticClass: "row-item" }, [
                          _c("div", { staticClass: "item-label" }, [
                            _vm._v("OnBoard Date"),
                          ]),
                          _c("div", { staticClass: "item-data" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFilete")(
                                    _vm.mblDetail?.clearence?.isf?.onBoardDate
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row-item" }, [
                          _c("div", { staticClass: "item-label" }, [
                            _vm._v("AMS SCAC"),
                          ]),
                          _c("div", { staticClass: "item-data" }, [
                            _vm._v(
                              _vm._s(_vm.mblDetail?.clearence?.isf?.amsscac)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row-item" }, [
                          _c("div", { staticClass: "item-label" }, [
                            _vm._v("AMS No."),
                          ]),
                          _c("div", { staticClass: "item-data" }, [
                            _vm._v(
                              _vm._s(_vm.mblDetail?.clearence?.isf?.amsblNumber)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row-item" }, [
                          _c("div", { staticClass: "item-label" }, [
                            _vm._v("Importer Bond Type"),
                          ]),
                          _c("div", { staticClass: "item-data" }, [
                            _vm._v(
                              _vm._s(
                                _vm.config.bondTypeOptions.find(
                                  (a) =>
                                    a.value ===
                                    _vm.mblDetail?.clearence?.isf?.bondType
                                )?.label
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row-item" }, [
                          _c("div", { staticClass: "item-label" }, [
                            _vm._v("Bill Number Type"),
                          ]),
                          _c("div", { staticClass: "item-data" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mblDetail?.clearence?.isf?.classification
                                  ? "分单"
                                  : "直单"
                              )
                            ),
                          ]),
                        ]),
                        _vm._l(_vm.addressRowArr, function (item, $index) {
                          return _c(
                            "div",
                            { key: $index, staticClass: "row-item" },
                            [
                              _c("div", { staticClass: "item-label" }, [
                                _vm._v(_vm._s(item.label1)),
                                _c("br"),
                                _vm._v(_vm._s(item.nameCH)),
                              ]),
                              _c("div", { staticClass: "address" }, [
                                item.label1 !== "Importer"
                                  ? _c("div", { staticClass: "conpanyName" }, [
                                      _c("span", [_vm._v("公司名")]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.mblDetail?.clearence?.isf?.[
                                              item.label2 + "Address"
                                            ]?.name
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "conpanyName" },
                                          [
                                            _c("span", [_vm._v("公司名")]),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.mblDetail?.clearence
                                                    ?.isf?.[
                                                    item.label2 + "Address"
                                                  ]?.name
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "conpanyName" },
                                          [
                                            _c("span", [_vm._v("EIN")]),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.mblDetail?.clearence?.isf
                                                    ?.importerEIN
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                item.label1 === "Importer"
                                  ? _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.importer?.address
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.cityAddress
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.provinceNameEN
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.countryCode
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.mblDetail?.clearence?.isf[
                                              item.label2 + "Address"
                                            ]?.importer?.postalCode
                                              ? _vm.mblDetail?.clearence?.isf[
                                                  item.label2 + "Address"
                                                ]?.importer?.postalCode
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.scin?.address
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.cityAddress
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.provinceNameEN
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              _vm.mblDetail?.clearence?.isf[
                                                item.label2 + "Address"
                                              ]?.countryCode
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.mblDetail?.clearence?.isf[
                                              item.label2 + "Address"
                                            ]?.scin?.postalCode
                                              ? _vm.mblDetail?.clearence?.isf[
                                                  item.label2 + "Address"
                                                ]?.scin?.postalCode
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ]),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "panle-container" },
                      [
                        _c("div", { staticClass: "table-header" }, [
                          _vm._v("+HS CODE列表"),
                        ]),
                        _c("BaseTable", {
                          attrs: {
                            height: "133",
                            tableData: _vm.tableData3,
                            isPager: false,
                            border: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c("UploadAttachmentDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          diaLogType: 1,
          rowData: _vm.rowData,
        },
        on: {
          close: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _c("EmailDetailDrawer", {
        attrs: {
          email: _vm.emailDetail.currEmail,
          visible: _vm.emailDetail.visible,
        },
        on: { close: _vm.closeEmailDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }